<template>
  <div id="profileDiv">
    <table>
        <tr><td><router-link v-bind:to="'/dashboard'">back</router-link></td></tr>
        <tr><td>
        {{this.uData.fullname}}
        </td></tr>
        <tr><td>
        <img v-bind:src='this.uData.filepath' style="max-width: 100px; height: auto; " />
        </td></tr>
         <tr><td>
        Department:{{this.uData.curdept}}
        </td></tr>
         <!-- <tr><td>
        Issued Date:{{this.uData.issueddate}}
        </td></tr> -->
         <tr><td>
        <div v-if="this.isShown">Id Expired</div>
        <div v-if="!this.isShown">Id Current</div>
        </td></tr>
        <!-- <tr><td>
        Expiry Date:{{this.uData.expirydate}}
        </td></tr> -->
    </table>

        
  </div>
</template>

<script>
import firebase from 'firebase';
import moment from 'moment';

export default {

  data(){
    return{
        id: this.$route.params.id,
        uData:{
            fullname: "",
            filepath: "",
            curdept: "",
            issueddate: "",
            expirydate: ""
        },
        isShown: null
    }
  },
    mounted(){
        var docRef = firebase.firestore().collection("Departmentdata").doc(this.id)

        docRef.get().then((doc) => {
            if(doc.exists){
                console.log(doc.data());
                this.uData.fullname = doc.data().fullname,
                this.uData.filepath = doc.data().imagepath,
                this.uData.curdept = doc.data().curdept,
                this.uData.issueddate = doc.data().issueddate,
                this.uData.expirydate = doc.data().expirydate

                var currentDate = new Date();
                
                
                var date1 = moment(currentDate).format("dd-mm-yyyy");
                var date2 = moment(this.uData.expiredate).format("dd-mm-yyyy");
                if(date1 >  date2){
                    this.isShown = true;
                } else {
                    this.isShown = false;
                }
            } else {
                console.log("Document doesn't exist");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        })
    }
 
}
</script>

<style>
#profileDiv{
    position: relative;
    top: 15%;
}
</style>
